import { format, parseISO } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
import { faHouse } from '@fortawesome/free-solid-svg-icons/faHouse';
import { isMinDate } from 'components/global/utils';
import { DeliveryStatus } from '@api/shipping-data/types/DeliveryStatus';



interface OrderTimesProps {
	plannedArrival: string | null;
	realArrival: string | null;
	etaArrival: string | null;
	deliveryStatus: DeliveryStatus;
	smsWasSent: boolean;
	arrivalsDeltaInMinutes: number;
}


export const OrderTimes = (props: OrderTimesProps) => {
	const { plannedArrival, realArrival, deliveryStatus, smsWasSent, arrivalsDeltaInMinutes, etaArrival } = props;

	const parsedPlannedArrival = plannedArrival && !isMinDate(plannedArrival) ? parseISO(plannedArrival) : null;
	const plannedArrivalResult = parsedPlannedArrival ? `${format(parsedPlannedArrival, 'H:mm')}` : '-';

	const parsedEtaArrival = etaArrival && !isMinDate(etaArrival) ? parseISO(etaArrival) : null;
	const etaArrivalResult = parsedEtaArrival ? `${format(parsedEtaArrival, 'H:mm')}` : '-';

	const parsedRealArrival = realArrival && !isMinDate(realArrival) ? parseISO(realArrival) : null;
	const realArrivalResult = parsedRealArrival ? `${format(parsedRealArrival, 'H:mm')}` : '-';


	const getStateByDelta = () => {
		const absoluteArrivalsDelta = Math.abs(arrivalsDeltaInMinutes);
		if (absoluteArrivalsDelta > 90) return ' state-danger';
		if (absoluteArrivalsDelta > 60) return ' state-warning';
		if (absoluteArrivalsDelta <= 60) return ' state-success';
		return '';
	};


	// order is delivered
	if (parsedPlannedArrival && parsedRealArrival) return (
		<p className={`component-order-times${getStateByDelta()}`}>
			<span className={smsWasSent ? 'state-underscore' : ''}>
				{plannedArrivalResult}
			</span> / {realArrivalResult}
		</p>
	)

	// order being delivered
	if (parsedPlannedArrival && parsedEtaArrival) return (
		<p className='component-order-times'>
			{deliveryStatus === DeliveryStatus.dc &&
				<FontAwesomeIcon icon={faHouse} />}
			{deliveryStatus === DeliveryStatus.truck &&
				<FontAwesomeIcon icon={faTruck} />}

			<span className={smsWasSent ? 'state-underscore' : ''}>
				{plannedArrivalResult}
			</span> / ~{etaArrivalResult}
		</p>
	)

	return (
		<></>
	)
}